/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeambulazioneAusilioCreateDTO
 */
export interface DeambulazioneAusilioCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof DeambulazioneAusilioCreateDTO
     */
    descrizione?: string;
}

/**
 * Check if a given object implements the DeambulazioneAusilioCreateDTO interface.
 */
export function instanceOfDeambulazioneAusilioCreateDTO(value: object): value is DeambulazioneAusilioCreateDTO {
    return true;
}

export function DeambulazioneAusilioCreateDTOFromJSON(json: any): DeambulazioneAusilioCreateDTO {
    return DeambulazioneAusilioCreateDTOFromJSONTyped(json, false);
}

export function DeambulazioneAusilioCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeambulazioneAusilioCreateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'descrizione': json['descrizione'] == null ? undefined : json['descrizione'],
    };
}

export function DeambulazioneAusilioCreateDTOToJSON(value?: DeambulazioneAusilioCreateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'descrizione': value['descrizione'],
    };
}

